import { render, staticRenderFns } from "./aurora-background.vue?vue&type=template&id=d7f9ec88&scoped=true"
import script from "./aurora-background.vue?vue&type=script&lang=js"
export * from "./aurora-background.vue?vue&type=script&lang=js"
import style0 from "./aurora-background.vue?vue&type=style&index=0&id=d7f9ec88&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7f9ec88",
  null
  
)

export default component.exports